<script>
import { defineAsyncComponent } from "vue";
import { componentStore } from "@common/componentStore/componentStore";
import { ddStore } from "@common/ddStore";
import { library } from "@common/library/library";
import { actionStore } from "@common/actionStore";

const vmsOrgRelationshipManagerConfig = {
    cId: "vmsOrgRelationshipManager",
    cType: "vmsOrgRelationshipManager",
    cTitle: "Relationship Manager",
    cTemplate: `<div class="vms-relationship-manager" :id="'vmsOrgRelationshipManagerWrapper' + cId">
                    <div class="vms-relationship-manager-relate-area">
                        <div class="vms-relationship-manager-left">
                            <div v-if="showNoKindMessage" class="no-kind-message">Please assign a Kind to this record in order to create relationships</div>
                            <div v-if="this.relationshipManagerMode === 'org_parent' && this.relationshipList?.records?.length !== 0" class="only-one-relationship-message">Only one parent organization may be selected</div>
                            <condensed-filter
                                v-if="!showNoKindMessage && !loading && (this.relationshipManagerMode !== 'org_parent' || this.relationshipList?.records?.length === 0)"
                                :cId="'condensedFilter__addRelationship' + cId"
                                :ref="'relationshipsListManagerFilter' + cId"
                                :prop-filter-options="filterOptions"
                                :prop-filter-items="recordList"
                                :prop-result="filteredItems"
                                :prop-additional-config="filterAdditionalConfig"
                                @update:prop-result="filteredItems = $event"
                                :prop-filtering=false
                                @update:prop-filtering="filtering = $event"
                                :prop-item-label="'Organization(s)'"
                            ></condensed-filter>
                        </div>
                        <div class="vms-relationship-manager-right">
                            <control name="BUTTON_GRID_SETTINGS"></control>
                        </div>
                        <div v-if="!showNoKindMessage && (this.relationshipManagerMode !== 'org_parent' || this.relationshipList?.records?.length === 0)" class="vms-relationship-manager-right">
                            <control name="BUTTON_AFFILIATE"></control>
                        </div>
                        <div class="clearfix"></div>
                    </div>
                    <div class="vms-relationship-manager-grid-area">
                        <div class="vms-relationship-manager-left">
                            <grid
                                :c-id="'grid__relationshipList' + cId"
                                ref="relationshipListManagerGrid"
                                @update:data-bound="relationshipsListDataBound($event)"
                                :prop-data="relationshipList"
                                :prop-settings="gridSettings"
                                :prop-selected-items="selectedItems"
                                @update:prop-selected-items="selectedItems = $event;"
                                :prop-selected-items-full-data="selectedItemsFullData"
                                @update:prop-selected-items-full-data="selectedItemsFullData = $event; disableButtons()"
                                :prop-row-bound-func="relRowBoundFunc"
                                :prop-row-selecting-func="relRowSelectingFunc"
                                
                            ></grid>
                        </div>
                        <div class="vms-relationship-manager-right">
                            <div class="vms-relationship-manager-grid-controls">
                                <control name="BUTTON_DELETE"></control>
                            </div>
                        </div>
                        <div class="clearfix"></div>
                    </div>
                </div>`,
    controls: [
        {
            name: 'BUTTON_AFFILIATE',
            type: 'button',
            label: 'Affiliate',
            onclick: 'affiliate'
        },
        {
            name: 'BUTTON_GRID_SETTINGS',
            type: 'button',
            label: 'Grid Settings',
            onclick: 'editGridSettings'
        },
        {
            name: 'BUTTON_DELETE',
            type: 'button',
            label: 'Unaffiliate',
            onclick: 'delete',
            disabled: true
        },
    ]
};

const editorSettings = {
    managerMode: {
        type: 'dropdown',
        label: 'Relationship Manager Mode',
        items: [
            { text: 'Org Parent', value: 'org_parent' },
            { text: 'Org Child', value: 'org_child' },
            { text: 'From Props', value: 'from_props' }
        ],
        fields: {
            text: 'text',
            value: 'value'
        },
        default: 'from_props'
    }
};

let vmsOrgRelationshipManagerCmp = {
    name: 'vmsOrgRelationshipManager',
    editorSettings,
    props: {
        relationshipManagerMode: {
            default: 'org_parent' /* possible values: 'org_parent', 'org_child' */
        },

    },
    data() {
        return {
            currentRecordId: 0,
            selectedRecordIds: [],
            filteredItems: {},
            recordList: {},
            relationshipList: {},
            selectedItems: {},
            selectedItemsFullData: {},
            gridSettingsSelectedItems: {},
            gridSettingsSelectedItemsFullData: {},
            gridSettingsSelectedItemsIndexes: [],
            gridSettings: {
                "paging": false,
                "sorting": true,
                "filtering": false,
                "grouping": false,
                "resizing": true,
                "width": '100%',
                "height": '310px',
                "enableCheckBox": true,
                "clipMode": "EllipsisWithTooltip",
            },
            orgKindsList: [],
            relInfo: [],
            relatioshipID: 0,
            relGridFieldList: {
                headers: [],
                records: []
            },
            relGridFieldListSelected: ['ORG_TITLE'],
            filterAdditionalConfig: {
                allowCustomValue: false,
                allowFiltering: true,
                filterType: 'Contains',
                showResultsAfterFiltersApplied: true,
                notShowMissingOptions: true,
                additionalValues: ['ORG_KIND']
            },
            customFilterOptions: {},
            currentRecordKind: false,
            loading: true
        };
    },
    computed: {
        showNoKindMessage() {
            return !this.loading && !this.currentRecordKind;
        },
        filterOptions() {
            return {
                ...this.customFilterOptions,
                ...{
                    RECORD_TITLE: {
                        label: 'All Organizations',
                        placeholder: 'Start typing to affiliate',
                        exactMatch: true,
                        fields: { text: 'text', value: 'RECORD_ID' },
                        itemTemplate: `<div class="vms-relationship-manager-item-template-wrapper">
                        <div class="vms-relationship-manager-item-template-text">{{data.text}}</div>
                        <div class="vms-relationship-manager-item-template-tag" v-if="data && data.additionalValue && data.additionalValue.ORG_KIND">
                            <div class="vms-relationship-manager-item-template-kind-tag">{{data.additionalValue.ORG_KIND}}</div>
                        </div>
                    </div>`
                    },
                    RECORD_ID: {
                        label: 'Organization ID', placeholder: 'Start typing to affiliate', exactMatch: true
                    }
                }
            };
        },
        managerMode() {
            return (!this.config || !this.config.managerMode || this.config.managerMode === 'from_props')
                ? this.relationshipManagerMode // from props
                : this.config.managerMode;
        }
    },
    methods: {
        async onLoad() {
            ddStore.preloadGroup('COMMON');
            // eslint-disable-next-line camelcase
            if (typeof profile_getFormObject === 'function') {
                let theForm = profile_getFormObject();
                if (theForm && theForm.recordID) {
                    this.currentRecordId = theForm.recordID.value;
                    // eslint-disable-next-line camelcase
                    if (typeof SmartTabs === 'object' && typeof general_resizeToContent === 'function') {
                        general_resizeToContent(1, 0, 5);
                    }
                }
            }
            if (!this.currentRecordId) {
                if (this.orgId) this.currentRecordId = this.orgId;
            }
            if (this.managerMode === 'org_parent') this.filterAdditionalConfig.maximumSelectionLength = 1;
            library.showLoadingIndicator('vmsOrgRelationshipManagerWrapper' + this.cId);
            await this.getRelationshipAttributes();
            await this.getRecordsLists();
            library.hideLoadingIndicator('vmsOrgRelationshipManagerWrapper' + this.cId);
            this.loading = false;
        },
        relationshipsListDataBound(isPreparingData) {
            this.$nextTick(() => {});
        },
        async getRelationshipAttributes() {
            let getAttrList = ['org_kind'];
            // get all data by one request
            await configStore.getAttrList(getAttrList);
            // get each data that already in store
            let tmpOrgKinds = await configStore.getAttrList(['org_kind']);
            for (let i in tmpOrgKinds) {
                if (i === 'length') continue;
                this.orgKindsList[this.orgKindsList.length] = { text: library.cloneObj(tmpOrgKinds[i]), value: parseInt(i, 10) };
            }
        },
        async getRecordsLists() {
            let response = await this.sDs.post('sds_orgRelationshipManagerGetData', this.managerMode, this.currentRecordId);
            if (response.status === 'success' && response.data) {
                this.recordList = {};
                if (this.$refs
                    && this.$refs['relationshipsListManagerFilter' + this.cId]
                    && typeof this.$refs['relationshipsListManagerFilter' + this.cId].clearAllFilters === 'function'
                ) {
                    this.$refs['relationshipsListManagerFilter' + this.cId].clearAllFilters();
                }
                if (response.data['currentRecordKind']) {
                    this.currentRecordKind = parseInt(response.data['currentRecordKind'], 10);
                }
                if (response.data['recordList']) {
                    let tmpRecordList = response.data['recordList'];
                    if (this.currentRecordKind && !library.objIsEmpty(this.orgKindsList)) {
                        let tmpCustomFilterOptions = {};
                        let filteredOrgKindsList = this.orgKindsList.filter((tmpOrgKind) => {
                            if ((this.currentRecordKind > 1000 && tmpOrgKind.value > 1000 && tmpOrgKind.value < 2000) || (this.currentRecordKind < 1000 && tmpOrgKind.value < 1000)) {
                                return (this.managerMode === 'org_child' ? tmpOrgKind.value > this.currentRecordKind : tmpOrgKind.value < this.currentRecordKind);
                            }
                            return false;
                        });
                        if (typeof filteredOrgKindsList.reverse === 'function' && this.managerMode === 'org_parent') filteredOrgKindsList = filteredOrgKindsList.reverse();
                        if (filteredOrgKindsList.length) {
                            for (let tmpI in tmpRecordList) {
                                if (tmpRecordList[tmpI]['ORG_KIND']) {
                                    let tmpCustomFilterOptionName = tmpRecordList[tmpI]['ORG_KIND'].toUpperCase().replaceAll(' ', '_');
                                    tmpRecordList[tmpI][tmpCustomFilterOptionName] = tmpRecordList[tmpI]['RECORD_TITLE'];
                                }
                            }
                            for (let tmpJ in filteredOrgKindsList) {
                                let tmpCustomFilterOption = library.cloneObj(this.filterOptions['RECORD_TITLE']);
                                tmpCustomFilterOption.fields = { text: 'RECORD_TITLE', value: 'RECORD_ID' };
                                tmpCustomFilterOption.label = filteredOrgKindsList[tmpJ].text;
                                let tmpCustomFilterOptionName = filteredOrgKindsList[tmpJ].text.toUpperCase().replaceAll(' ', '_');
                                tmpCustomFilterOptions[tmpCustomFilterOptionName] = tmpCustomFilterOption;
                            }
                            this.customFilterOptions = tmpCustomFilterOptions;
                        }
                    }
                    this.recordList = tmpRecordList;
                }
                this.relationshipList = {};
                if (response.data['relationshipList']) {
                    this.relationshipList = {};
                    let relationshipList = {
                        headers: [],
                        records: []
                    };
                    if (response.data['gridColumnsList']) {
                        let colWidth = Math.ceil(620 / response.data['gridColumnsList'].length);
                        for (let i in response.data['gridColumnsList']) {
                            if (i === 'length') continue;
                            let outputName = library.cloneObj(response.data['gridColumnsList'][i]['displayTitle']);
                            outputName = outputName.split('::').length > 1 ? outputName.split('::')[1] : outputName;
                            relationshipList.headers.push({
                                text: outputName,
                                field: library.cloneObj(response.data['gridColumnsList'][i]['COL_NAME']),
                                width: colWidth,
                                allowSorting: !response.data['gridColumnsList'][i]['MULTIPLE']
                            });
                        }
                    } else {
                        relationshipList.headers.push({
                            text: 'Organization',
                            field: 'RECORD_TITLE',
                            width: 660,
                        });
                    }
                    if (relationshipList.headers.length) {
                        this.gridSettings['sortSettings'] = {
                            columns: [
                                {
                                    field: relationshipList.headers[0].field,
                                    direction: 'Ascending'
                                }
                            ]
                        };
                    }
                    for (let i in response.data['relationshipList']) {
                        if (i === 'length') continue;
                        let tmp = library.cloneObj(response.data['relationshipList'][i]);
                        tmp['RECORD_TITLE'] = library.cloneObj(tmp['RECORD_TITLE']);
                        tmp['rowID'] = tmp['RELATIONSHIP_ID'];
                        relationshipList.records.push(tmp);
                    }
                    this.relationshipList = library.cloneObj(relationshipList);
                }
            }
        },
        disableButtons() {
            if (this.controls) {
                this.controls['BUTTON_DELETE'].disabled = true;
                if (this.selectedItems.length >= 1) {
                    this.controls['BUTTON_DELETE'].disabled = false;
                }
            }
        },
        async affiliate() {
            this.selectedRecordIds = [];
            if (this.filteredItems) {
                for (let i in this.filteredItems) {
                    if (i === 'length') continue;
                    this.selectedRecordIds.push(this.filteredItems[i].RECORD_ID);
                }
            }
            if (this.managerMode === 'org_parent') {
                await this.sDs.post('sds_createOrgRelationship', this.selectedRecordIds, this.currentRecordId);
            } else {
                await this.sDs.post('sds_createOrgRelationship', this.currentRecordId, this.selectedRecordIds);
            }
            this.getRecordsLists();
        },
        async editGridSettings() {
            // init self to be used in template
            let self = this;
            if (this.relGridFieldList.records.length === 0) {
                // function to process results of sds_getAvailableFields call
                let editGridSettingsPrepareList = (relGridFieldList, data) => {
                    for (let i in data) {
                        if (i === 'length') continue;
                        let tmp = library.cloneObj(data[i]);
                        tmp['COL_NAME'] = library.cloneObj(tmp['displayTitle']);
                        tmp['rowID'] = i;
                        relGridFieldList.push(tmp);
                    }
                    return relGridFieldList;
                };
                // init grid contents array
                this.relGridFieldList = {
                    headers: [],
                    records: []
                };
                this.relGridFieldList.headers.push({
                    text: 'Select the fields to be displayed',
                    field: 'COL_NAME'
                });
                let response;
                // retrieve list of organization grid fields
                response = await this.sDs.post('sds_getAvailableFields', 3);
                if (response.status === 'success' && response.data) {
                    this.relGridFieldList.records = editGridSettingsPrepareList(this.relGridFieldList.records, response.data);
                }
            }
            if (this.relGridFieldList.records.length > 0) {
                // retrieve list of selected columns, and get indexes
                let response = await this.sDs.post('er_getEcUserProperty', 'vmsOrgRelationshipManager_' + this.managerMode + '_gridList');
                if (response.status === 'success' && response.data) {
                    let tmpRelGridFieldListSelected = library.cloneObj(response.data);
                    this.relGridFieldListSelected = tmpRelGridFieldListSelected.split(',').length > 1 ? tmpRelGridFieldListSelected.split(',') : [tmpRelGridFieldListSelected];
                } else {
                    this.relGridFieldListSelected = ['ORG_TITLE'];
                }
                this.gridSettingsSelectedItemsIndexes = [];
                // cycle through list to get indexes
                for (let i in this.relGridFieldListSelected) {
                    let tmpIdx = 0;
                    for (let j in this.relGridFieldList.records) {
                        if (this.relGridFieldList.records[j].rowID === this.relGridFieldListSelected[i]) {
                            this.gridSettingsSelectedItemsIndexes.push(tmpIdx);
                            break;
                        }
                        tmpIdx++;
                    }
                }
                // grid settings window template
                let tmpUniqueID = self.cId + '_' + library.getUniqueID();
                let vmsOrgRelationshipManagerGridSettingsTemplate = {
                    name: "vmsOrgRelationshipManager-gridSettings-popup_" + tmpUniqueID,
                    template: `
                        <div class="vms-relationship-manager-gridSettings">
                            <div class="vms-relationship-manager-edit-status">
                                <grid
                                    :c-id="'grid__gridColumnsList' + this.outer_cId"
                                    ref="relationshipListManagerGridSettingsGrid"
                                    @update:data-bound="gridSettingsDataBound($event)"
                                    :prop-data="relGridFieldList"
                                    :prop-settings="gridSettings"
                                    :prop-selected-items="selectedItems"
                                    @update:prop-selected-items="selectedItems = $event;"
                                    :prop-selected-items-full-data="selectedItemsFullData"
                                    @update:prop-selected-items-full-data="selectedItemsFullData = $event; optionChanged()"
                                ></grid>
                            </div>
                        </div>
                    `,
                    data() {
                        return {
                            outer_cId: tmpUniqueID,
                            relGridFieldList: self.relGridFieldList,
                            gridSettings: {
                                "paging": false,
                                "sorting": true,
                                "filtering": true,
                                "filterSettings": {
                                    "mode": "Immediate",
                                    "immediateModeDelay": 1000,
                                    "filter": {
                                        "matchCase": false,
                                        "operator": 'contains'
                                    }
                                },
                                "selectionSettings": {
                                    "persistSelection": true
                                },
                                "hideFindButton": true,
                                "grouping": false,
                                "resizing": true,
                                "width": '100%',
                                "height": '310px',
                                "enableCheckBox": true,
                                "clipMode": "EllipsisWithTooltip",
                            },
                            selectedItemsIndexes: self.gridSettingsSelectedItemsIndexes,
                            selectedItems: self.gridSettingsSelectedItems,
                            selectedItemsFullData: self.gridSettingsSelectedItemsFullData,
                            controls: {},
                            initialDataBound: true
                        };
                    },
                    mounted() {},
                    methods: {
                        gridSettingsDataBound() {
                            if (!this.initialDataBound) return;
                            this.initialDataBound = false;
                            this.$nextTick(() => {
                                if (this.$refs
                                    && this.$refs['relationshipListManagerGridSettingsGrid']
                                    && this.$refs['relationshipListManagerGridSettingsGrid'].$refs
                                    && this.$refs['relationshipListManagerGridSettingsGrid'].$refs['grid__gridColumnsList' + this.outer_cId]
                                    && this.$refs['relationshipListManagerGridSettingsGrid'].$refs['grid__gridColumnsList' + this.outer_cId].ej2Instances
                                    && typeof this.$refs['relationshipListManagerGridSettingsGrid'].$refs['grid__gridColumnsList' + this.outer_cId].ej2Instances.selectRows === 'function'
                                ) {
                                    this.$refs['relationshipListManagerGridSettingsGrid'].$refs['grid__gridColumnsList' + this.outer_cId].ej2Instances.selectRows(this.selectedItemsIndexes);
                                }
                            });
                        },
                        optionChanged() {
                            self.gridSettingsSelectedItemsFullData = this.selectedItemsFullData;
                        },
                    },
                    updated() {},
                    components: {
                        control: defineAsyncComponent(() => import('@common/control/control.vue')),
                    },
                };
                let funcOnSuccess = () => {
                    if (this.gridSettingsSelectedItemsFullData.length > 5) {
                        library.showDialog('Please choose no more than 5 columns', false, false, { title: 'Error', showAsAlert: true });
                        return false;
                    }
                    let columnsList = [];
                    for (let i in this.gridSettingsSelectedItemsFullData) {
                        if (i === 'length') continue;
                        columnsList[columnsList.length] = this.gridSettingsSelectedItemsFullData[i].rowID;
                    }
                    this.sDs.post('er_setEcUserProperty', 'vmsOrgRelationshipManager_' + this.managerMode + '_gridList', columnsList.join(',')).then((response) => {
                        if (response.status === 'success') {
                            this.getRecordsLists();
                        }
                    });
                    return true;
                };
                let funcOnFailure = () => {};
                let opt = {
                    title: 'Grid Settings',
                    name: 'vmsOrgRelationshipManagerGridSettingsTemplateDialog',
                    preventCloseOnBackdropClick: false,
                    // size: 'fullscreen',
                    height: '530px',
                    doNotCloseOnOK: true,
                    showCloseIcon: true,
                    closeOnEscape: true,
                    doNotCloseOnFuncFailure: true
                };
                library.showDialog(vmsOrgRelationshipManagerGridSettingsTemplate, funcOnSuccess, funcOnFailure, opt);
            }
        },
        async delete() {
            if (this.selectedItems.length) {
                let relListToDelete = [];
                for (let i in this.selectedItemsFullData) {
                    if (i === 'length') continue;
                    relListToDelete[relListToDelete.length] = this.selectedItemsFullData[i].RELATIONSHIP_ID;
                }
                if (relListToDelete.length) {
                    let title = await ddStore.getAlias('COMMON', 'ERRORMESSAGE_DELETE_THE_TITLE');
                    let message = '';
                    if (relListToDelete.length === 1) {
                        message = await ddStore.getAlias('COMMON', 'ERRORMESSAGE_DELETE', 'affiliation');
                    } else {
                        message = await ddStore.getAlias('COMMON', 'ERRORMESSAGE_MULTIDELETE', 'affiliations');
                    }
                    library.showDialog(message, async () => {
                        await this.sDs.post('sds_deleteOrgRelationship', relListToDelete);
                        this.getRecordsLists();
                    }, false, { title: title });
                }
            }
        },
        relRowBoundFunc(t, args) {
            if (args.data.IS_READONLY === 1) {
                args.row.classList.add('e-disabled');
            }
        },
        relRowSelectingFunc(t, args) {
            if (args.data.IS_READONLY === 1) {
                args.cancel = true;
            }
            if (args.rowIndexes.length > 1) {
                let index = [];
                args.rowIndexes.filter((rowIndex) => {
                    if (t.$refs[t.ref].getRowByIndex(rowIndex).classList.contains('e-disabled')) {
                        index.push(rowIndex);
                    }
                    return index;
                });
                index.forEach((p) => args.rowIndexes.splice(args.rowIndexes.indexOf(p), 1));
            }
        }
    }
};

componentStore.initComponent(vmsOrgRelationshipManagerCmp, vmsOrgRelationshipManagerConfig);
export { vmsOrgRelationshipManagerCmp, vmsOrgRelationshipManagerConfig };
export default vmsOrgRelationshipManagerCmp;

</script>

<style scoped>
.vms-relationship-manager {
    padding: 5px;
    width: 790px;
}
.vms-relationship-manager-grid-controls {
    padding: 5px;
}
.vms-relationship-manager-grid-controls .control {
    margin-top: -5px;
    margin-right: 5px;
}
.vms-relationship-manager-left {
    float: left;
}
.vms-relationship-manager-right {
    float: right;
}
.vms-relationship-manager-relate-area {
    width: 690px;
}
.vms-relationship-manager-relate-area .vms-relationship-manager-left {
    width: 440px;
}
.vms-relationship-manager-relate-area .vms-relationship-manager-right {
    margin-top: 7px;
    padding-left: 5px;
}
.vms-relationship-manager .left-controls > div, .right-controls > div {
    display: inline-block;
}
.vms-relationship-manager .clearfix {
    clear: both;
}
.vms-relationship-manager-grid-area .vms-relationship-manager-left {
    width: 690px;
}

:deep(.vms-relationship-manager .filter-status) {
    display: none;
}
:deep(.vms-relationship-manager .e-columnheader  *) {
    background-color: #cfd8dc !important;
    color: black !important;
    border-color: #757575 !important;
}
:deep(.vms-relationship-manager .e-columnheader  .e-rhandler) {
    border-right-color: white !important;
    border-right-style: dashed !important;
}
:deep(.vms-relationship-manager .e-headercelldiv) {
    text-align: left !important;
}
:deep(.vms-relationship-manager .e-gridheader) {
    background-color: #cfd8dc !important;
}
</style>

<style>
.vms-relationship-manager-item-template-wrapper {
    display: table;
}
.vms-relationship-manager-item-template-text {
    width: 100%;
    text-wrap: wrap;
    text-indent: 0px;
    padding-left: 16px;
}
.vms-relationship-manager-item-template-text, .vms-relationship-manager-item-template-tag {
    display: table-cell;
}
.vms-relationship-manager-item-template-tag {
    vertical-align: middle;
}
.vms-relationship-manager-item-template-kind-tag {
    background-color: #e8e2e7;
    color: #484848;
    text-align: center;
    height: fit-content;
    width: fit-content;
    font-size: smaller;
    padding: 3px;
    line-height: normal;
    display: block;
    text-indent: 0px;
}

.vms-relationship-manager-item-template-kind-tag:empty
{
    display:none;
}

.no-kind-message .only-one-relationship-message {
    line-height: 40px;
}
</style>
